import { forEachRoll, OVERLAP_ENUMERATION_MAX_COMBOS } from './formula-extrema.js';
const NO_VERDICT = { alwaysSubsumed: false, alwaysOverlaps: false, mayCollide: false };
const declined = (n) => ({
    per: Array.from({ length: n }, () => NO_VERDICT),
    any: NO_VERDICT,
    // Never wrongly accuse, and never wrongly reassure: with no sweep to prove it over, no claim.
    claimHoldsAlways: false,
});
export function analyseOverlapAcrossRolls(opts) {
    const { triggers, names, variables, atRoll, budget = OVERLAP_ENUMERATION_MAX_COMBOS } = opts;
    if (triggers.length === 0)
        return declined(0);
    // Indexed by POSITION, never keyed by the trigger string: two conditions may legitimately carry
    // the same text, and a map would count one of them twice and read as `always`.
    const subsumedIn = new Array(triggers.length).fill(0);
    const collidedIn = new Array(triggers.length).fill(0);
    let rolls = 0;
    let claimIn = 0;
    let undecidable = false;
    const tally = (roll) => {
        const judge = atRoll(roll);
        if (!judge) {
            undecidable = true;
            return 'stop';
        }
        rolls++;
        triggers.forEach((trigger, i) => {
            const sub = judge.subsumed(trigger);
            if (sub)
                subsumedIn[i]++;
            if (sub || judge.overlaps(trigger))
                collidedIn[i]++;
        });
        if (judge.claim)
            claimIn++;
        return undefined;
    };
    if (names.length === 0) {
        // Nothing varies on either side, so one evaluation settles it and every verdict is certain.
        // This is the path a block with no variables takes, and it must behave exactly as the
        // single-roll check it replaces.
        if (tally({}) === 'stop')
            return declined(triggers.length);
    }
    else if (!forEachRoll(names, variables, tally, budget)) {
        return declined(triggers.length);
    }
    if (undecidable || rolls === 0)
        return declined(triggers.length);
    const per = triggers.map((_, i) => ({
        alwaysSubsumed: subsumedIn[i] === rolls,
        // Subsumption is the more specific finding, so a condition reported as always-subsumed is not
        // also reported here. One that is subsumed in some rolls and merely overlapping in the rest
        // still collides every time, which is what this says.
        alwaysOverlaps: collidedIn[i] === rolls && subsumedIn[i] < rolls,
        mayCollide: collidedIn[i] > 0 && collidedIn[i] < rolls,
    }));
    return {
        per,
        any: {
            alwaysSubsumed: per.some(v => v.alwaysSubsumed),
            alwaysOverlaps: per.some(v => v.alwaysOverlaps),
            mayCollide: per.some(v => v.mayCollide),
        },
        claimHoldsAlways: claimIn === rolls,
    };
}
//# sourceMappingURL=trigger-overlap.js.map